import React from "react";
import { Card, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import moment from "moment";

type User = {
  id: number;
  name: string;
  img_url: string;
};

type Comment = {
  id: number;
  fk_ticket_id: number;
  fk_user_id: number;
  comment: string;
  commented_date: string;
  type: string;
  CreateDate: string;
  user: User;
};

type CommentListProps = {
  comments: Comment[];
};

export default function CommentList({ comments }: CommentListProps) {
  return (
    <div style={{ color: "white" }}>
      {comments.map((comment) => (
        <Card
          key={comment.id}
          title={comment.user.name || "Anonymous"}
          style={{
            boxShadow: "0 6px 18px rgba(0,0,0,0.22)",
            marginTop: 20,
            borderWidth: 1,
            borderRadius: 16,
            borderColor: "rgba(255,255,255,0.08)",
          }}
        >
          <Card.Meta
            avatar={
              comment.user.img_url ? (
                <Avatar src={comment.user.img_url} />
              ) : (
                <Avatar icon={<UserOutlined />} />
              )
            }
            title={`Commented on: ${moment(comment.commented_date).format(
              "DD/MM/YYYY hh:mm A"
            )}`}
            description={comment.comment}
            style={{ color: "white" }}
          />
        </Card>
      ))}
    </div>
  );
}
